import Button from 'react-bootstrap/Button';
import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import { Link } from "react-router-dom";
import { Thunderbolt } from 'react-bootstrap-icons';

export class ActivePicks extends Component {
    static displayName = ActivePicks.name;
    constructor(props) {
        super(props);
        this.state = {
            loading: false, clientPickInfo: null
        };
        this.history = props.history;

    }
    componentDidMount() {
        if (typeof this.props.location.state.activePicks === 'undefined') {
            this.getActivePicksForClient();

        }
        else {
            this.setState({ clientPickInfo: this.props.location.state.activePicks });
        }



    }
    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }

    render() {
        var parent = this;
        return (
            <div>
                {this.state.clientPickInfo == null && this.state.loading && <div className="p1"> <em>Loading client active picks ... </em></div>}
                { this.state.clientPickInfo != null && <> <h4>{this.state.clientPickInfo.name} ({this.state.clientPickInfo.nameCode})</h4>
                    <h5>Active Picks ({this.state.clientPickInfo.activePicks.length})</h5>
                    <div>

                        {this.state.clientPickInfo.activePicks.map(function (item) {
                            var child = parent;
                            return (
                                <Card className="mb-1" key={item.pickNumber}>
                                    <Card.Header>
                                        {item.pickNumber}
                                    </Card.Header  >
                                    <Card.Body>
                                        <Card.Text>
                                            <span><b>Allocated:</b> {item.allocated}</span><br />
                                            <span><b>Picked:</b> {item.picked}</span><br />
                                            <span><b>Balance:</b> {item.balance}</span><br />
                                            <Button type="button" className="btn btn-success col-12 mb-2 mt-1" onClick={() => { child.goto('MHEWithPickRows', { selectedPick: item }) }}>Pick List</Button>

                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            );
                        })}


                    </div>
                </>}
            </div>
        );
    }

    getActivePicksForClient() {
        this.setState({ loading: true });
        fetch(`api/PaperlessPicking/GetAllActivePicks?warehouseId=${MyGlobal.warehouse}&nameCode=${this.props.location.state.nameCode}`)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const result = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    var errorDetail = JSON.parse(errorText);
                    var error = JSON.stringify(errorDetail.errors);
                    this.setState({ alertMessage: error, loading: false });
                }
                else {
                    if (result.success) {
                        this.setState({ loading: false, clientPickInfo: result.data[0] });
                    }
                    else {
                        this.setState({ alertMessage: result.errorMessage });
                    }

                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }
}
export default ActivePicks;

